module.exports = {
    FIPRE: 'FIPRE',
    PRE_APROB: 'Carta de preaprobación',
    TAS: 'Tasación',
    TAS_DICT: 'Dictamen de Tasación',
    TAS_CERT: 'Certificado de Tasación',
    TAS_CERT_CLI: 'Certificado de Tasación aportado por el cliente',
    TAS_CLI: 'Tasación aportada por el cliente',
    TAS_FACT: 'Factura de Tasación',
    OV: 'Oferta Vinculante',
    FIPER: 'FIPER',
    DRAFT_CONT: 'Borrador contrato',
    IDEP: 'IDEP (Andalucía)',
    DIPERC: 'DIPERC (Andalucía)',
    NOM: 'Nómina',
    VL: 'Vida Laboral',
    NOM_VL: 'Nómina-Vida Laboral',
    IRPF100_CLI: 'IRPF100 del cliente',
    IRPF100: 'IRPF 100',
    IRPF130: 'IRPF 130',
    BASES_COTIZ: 'Bases de cotización',
    RECIBO_HIPOTECA: 'Recibo Hipoteca',
    NS: 'Nota Simple',
    NS_CLI: 'Nota Simple del cliente',
    IJ_NS: 'Informe Jurídico Nota Simple',
    NS_FACT: 'Factura de Nota Simple',
    SOL_PRE: 'Solicitud de Préstamo Hipotecario',
    397: 'Póliza del seguro',
    PRE_POLIZA_SEGURO_HOGAR: 'Solicitud de Seguro',
    RECIB_HOGAR: 'Seguro vigente',
    RECIB_PREST: 'Recibo Préstamo',
    RECIB_HIPO: 'Recibo Hipoteca',
    248: 'Nota simple inscrita en el registro',
    177: 'Documentos pre-contractuales firmados',
    107: 'Escritura firmada',
    187: 'Facturas asociadas a gastos de compraventa e hipoteca',
    DNI_FRONT: 'DNI frente',
    DNI_BACK: 'DNI dorso',
    MINUTA: 'Proyecto de contrato',
    MANIFESTACION_FIRMADA_HIPO: 'Manifestación firmada',
    INF_CUOTAS_HIPO: 'Escenario de cuotas',
    FEIN: 'Ficha Europea de Información Normalizada (FEIN) + Anexo con finca',
    FIAE: 'Ficha de advertencias estandarizadas (FIAE)',
    INF_GASTOS_HIPO: 'Información de gastos',
    ADVERTENCIA_HIPO: 'Asesoramiento Obligatorio',
    INSURANCE_PRE_POLICY: 'Condiciones de la garantía del seguro',
    NOM_1: 'Nómina 1',
    NOM_2: 'Nómina 2',
    NOM_3: 'Nómina 3',
    JUST_INGRESO1: 'Justificante de ingreso nómina 1',
    JUST_INGRESO2: 'Justificante de ingreso nómina 2',
    OTROS: 'Otros (alquileres, escrituras, impuestos patrimonio)',
    OTROS_DOC_INTERVINIENTE: 'Otros (Documentación a nivel de interviniente)',
    UNKNOWN: 'Desconocido',
};
